import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ClinicEditModal({ isOpen, onClose, clinica, onSave }) {
  const [formData, setFormData] = useState({
    id: '',
    nome: '',
    endereco: '',
    telefone: '',
    cnpj: '',
    email: '',
    representante: '',
  });

  useEffect(() => {
    if (clinica) {
      setFormData({
        id: clinica.id || '',
        nome: clinica.nome || '',
        endereco: clinica.endereco || '',
        telefone: clinica.telefone || '',
        cnpj: clinica.cnpj || '',
        email: clinica.email || '',
        representante: clinica.representante || '',
      });
    }
  }, [clinica]);

  if (!isOpen || !clinica) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Salvar os dados e aguardar a conclusão
      await onSave(formData);

      // Exibe toast de sucesso
      toast.success('Clínica salva com sucesso!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Fecha o modal após salvar com sucesso
      onClose();
    } catch (error) {
      // Exibe toast de erro
      toast.error('Erro ao salvar a clínica. Tente novamente.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6 relative">
        <button
          className="absolute top-4 right-4 text-2xl text-gray-500 hover:text-gray-700 transition focus:outline-none"
          onClick={onClose}
          aria-label="Fechar Modal"
        >
          &times;
        </button>
        <h2 className="font-semibold text-center text-primary mb-6">
          Editar Clínica
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label
                htmlFor="nome"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                Nome:
              </label>
              <input
                type="text"
                id="nome"
                name="nome"
                placeholder="Nome da clínica"
                value={formData.nome}
                onChange={handleInputChange}
                className="p-3 border border-gray-300 rounded-md focus:border-teal-500 focus:ring-teal-500"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="endereco"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                Endereço:
              </label>
              <input
                type="text"
                id="endereco"
                name="endereco"
                placeholder="Endereço completo"
                value={formData.endereco}
                onChange={handleInputChange}
                className="p-3 border border-gray-300 rounded-md focus:border-teal-500 focus:ring-teal-500"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="telefone"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                Telefone:
              </label>
              <InputMask
                mask="(99) 99999-9999"
                id="telefone"
                name="telefone"
                placeholder="(00) 00000-0000"
                value={formData.telefone}
                onChange={handleInputChange}
                className="p-3 border border-gray-300 rounded-md focus:border-teal-500 focus:ring-teal-500"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="cnpj"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                CNPJ:
              </label>
              <InputMask
                mask="99.999.999/9999-99"
                id="cnpj"
                name="cnpj"
                placeholder="00.000.000/0000-00"
                value={formData.cnpj}
                onChange={handleInputChange}
                className="p-3 border border-gray-300 rounded-md focus:border-teal-500 focus:ring-teal-500"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="email"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                Email:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="exemplo@dominio.com"
                value={formData.email}
                onChange={handleInputChange}
                className="p-3 border border-gray-300 rounded-md focus:border-teal-500 focus:ring-teal-500"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="representante"
                className="text-sm font-medium text-gray-700 mb-1"
              >
                Representante Legal:
              </label>
              <input
                type="text"
                id="representante"
                name="representante"
                placeholder="Nome do representante"
                value={formData.representante}
                onChange={handleInputChange}
                className="p-3 border border-gray-300 rounded-md focus:border-teal-500 focus:ring-teal-500"
              />
            </div>
          </div>
          <button
            type="submit"
            className="p-6 bg-primary text-white py-3 rounded-lg mt-4 hover:bg-secondary transition focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            Salvar
          </button>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
}

// Adicionando PropTypes para validação das propriedades
ClinicEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clinica: PropTypes.shape({
    id: PropTypes.string,
    nome: PropTypes.string,
    endereco: PropTypes.string,
    telefone: PropTypes.string,
    cnpj: PropTypes.string,
    email: PropTypes.string,
    representante: PropTypes.string,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default ClinicEditModal;
